import React, {useContext, useEffect, useState} from "react"
import Typography from "../../../reusable/Typography/Typography"
import {useTranslation} from "next-i18next"
import Button from "../../../reusable/components/Button"
import {QuizzContext} from "../../../../context/QuizzContext"
import {ArrowLeft, ArrowRight, ChevronDown, Search} from "react-bootstrap-icons"
import DataContext from "../../../../context/DataContext"
import {formatImageSrc} from "../../../../strapi/strapiHelpers"
import LayoutContext from "../../../../context/LayoutContext"
import MobileModal from "../../../reusable/MobileModal"
import Drawer from "../../../reusable/components/Drawer/Drawer"
import MoreWaysToFindEbikeQuizCta from "../MoreWaysToFindEbikeQuizCta"
import NarrowScope from "../NarrowScope"
import RenderQuizOptions from "../RenderQuizOptions"

function ThirdQuiz() {
	const {t} = useTranslation()
	const {appendQuizAnswers, quizzData, setActiveQuizz, isLoadingProductsCount, totalNumberOfProducts, updateUserQuizzChoices, brandsList, brandsToShow, setBrandsToShow} = useContext(QuizzContext)
	const {brands} = useContext(DataContext)

	const [searchTerm, setSearchTerm] = useState("")
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [narrowScope, setNarrowScope] = useState(false)
	const [isDrawerOpen, setIsDrawerOpen] = useState(false)

	const [activeIndexes, setActiveIndexes] = useState<number[]>(() => {
		const actives = []
		quizzData?.brand?.forEach(item => {
			const activeIndex = brandsList?.findIndex(cat => cat.value === item)
			if (activeIndex >= 0) {
				actives.push(activeIndex)
			}
		})
		return actives
	})

	const performSearch = value => {
		if (value) {
			setBrandsToShow(() => brandsList?.filter(val => val.title.toLowerCase().startsWith(value) || val.value.startsWith(value)))
		} else {
			(
				setBrandsToShow(brandsList)
			)
		}
	}

	useEffect(() => {
		const answers = activeIndexes.map(indexItem => brandsList?.[indexItem]?.value).filter(Boolean)
		appendQuizAnswers(answers, "brand")
	}, [activeIndexes])

	const {isMobile} = useContext(LayoutContext)
	if (!narrowScope) {
		return (
			<div className="d-flex col-12 align-items-start justify-content-start gap-3 flex-column">

				<div style={{gap: "4px"}}
					className="d-flex col-12 align-items-start justify-content-start flex-column">
					<Typography style={{fontSize: "20px", lineHeight: "32px"}}
						variant="bodySmBold">{t("select-brand-quiz")}</Typography>
				</div>
				<div style={{borderRadius: "4px"}}
					className="d-flex py-2 px-3 border col-12 align-items-center justify-content-between">
					<input placeholder={t("search-brand")}
						style={{outline: "none", border: "none", flex: 1}}
						value={searchTerm}
						onChange={e => {
							setSearchTerm(e.target.value)
							performSearch(e.target.value)
						}} />
					<Search />
				</div>
				<div className="d-flex col-12 align-items-center justify-content-start gap-1 flex-wrap">
					<RenderQuizOptions isBrands
						activeIndexes={activeIndexes}
						setActiveIndexes={setActiveIndexes}
						options={brandsToShow || []} />
				</div>
				<div onClick={() => {
					if (isMobile) {
						setIsModalOpen(true)
					} else {
						setIsDrawerOpen(true)
					}
				}}
				style={{background: "#FFE9C2", borderRadius: "4px"}}
				className="d-flex cursor-pointer col-12 p-3 align-items-center justify-content-between">
					<Typography style={{fontSize: "14px", lineHeight: "20px"}}
						variant="bodySm">{t("select-other-brands")}</Typography>
					<ChevronDown size={17} />
				</div>
				<MobileModal modalTitle={t("select-other-brands")}
					handleClose={() => setIsModalOpen(false)}
					modalOpen={isModalOpen} >
					<div
						className="p-2">
						<div className="d-flex p-4 align-items-start justify-content-start gap-3 flex-column"
							style={{maxHeight: "60dvh", overflowY: "auto"}}><RenderQuizOptions useBrandTitle
								activeIndexes={activeIndexes}
								setActiveIndexes={setActiveIndexes}
								options={brandsList || []} />
						</div>
					</div>
				</MobileModal>
				<Drawer closeOnTouch
					isOpen={isDrawerOpen}
					closeModal={() => setIsDrawerOpen(false)} ><div style={{minWidth: "26rem", maxHeight: "95dvh", overflowY: "auto"}}
						className="p-4">
						<Typography style={{fontSize: "28px", lineHeight: "36px"}}
							variant="bodySmBold">{t("select-other-brands")}</Typography>
						<div className="d-flex pt-4 gap-3 flex-column"
						><RenderQuizOptions useBrandTitle
								activeIndexes={activeIndexes}
								setActiveIndexes={setActiveIndexes}
								options={brandsList || []} /></div>
					</div></Drawer>
				<div className="col-12 d-flex align-items-center justify-content-start">
					<ArrowLeft className="col-1 cursor-pointer"
						size={20}
						onClick={() => {
							setActiveQuizz(prev => prev - 1)
						}} />
					<Button bgColor="#FEC04D"
						icon={<ArrowRight size={20} />}
						fontSizeSmall
						className="col-11"
						onClick={() => {
							if (!isLoadingProductsCount && Number(totalNumberOfProducts) !== 0) {
								updateUserQuizzChoices().then(() => setActiveQuizz(prev => prev + 1))
							} else {
								setNarrowScope(true)
							}
						}}
						label={t("Continue")} />
				</div>
				<div className="px-3 container border-top col-11" />
				<MoreWaysToFindEbikeQuizCta />
			</div>

		)
	}

	return <NarrowScope setNarrowScope={setNarrowScope} />
}

export default ThirdQuiz
